import React, { useEffect, useState } from "react";
import "../styles/about.css";
import { Link } from "react-router-dom";
import Header from "./header";

export default function About() {
  const [isScrolled, setIsScrolled] = useState(false);

  useEffect(() => {
    // Add an event listener to track scroll position
    window.addEventListener("scroll", handleScroll);
    // Clean up the event listener on unmount
    return () => {
      window.removeEventListener("scroll", handleScroll);
    };
  }, []);

  const handleScroll = () => {
    if (window.scrollY > 100) {
      setIsScrolled(true);
    } else {
      setIsScrolled(false);
    }
  };

  return (
    <div>
      <Header />
      <div className={`container-sm pt-3 px-4 overflow-hidden ${isScrolled ? "scrolled" : ""}`}>
        <div className='row mb-4 mt-5 py-2'>
          <img
            className='people px-0'
            src={process.env.PUBLIC_URL + "/ukhanya.jpeg"}
            alt=''
          />
          <div className={`ukhanya-card ${isScrolled ? "scrolled" : ""}`}>
            <div className='col-3'>
              <img
                src={process.env.PUBLIC_URL + "/Ellipse.svg"}
                alt=''
                className={`ellipse-image ${isScrolled ? "scrolled" : ""}`}
              />
            </div>
            <div className="ukhanya">
              <h5 className='ukhanya-text'>uKhanya Foundation</h5>
              <small className='ayoba-foundation'>
                ayoba verified organisation
              </small>
            </div>
          </div>
        </div>

        <div className='ukhanya-save'>
          <p className='save-the-children'>
            Save the Children believes every child deserves a future. We work in
            over 120 countries to save lives, fight for rights, and provide
            education, healthcare and child protection services to children,
            adolescents, and their families, with a particular focus on the most
            vulnerable and excluded.
          </p>
          <p className='save-the-children py-3'>
            We have been working for over 100 years, and we are proud to have
            helped millions of children survive, learn, and thrive. But there is
            still so much more to do. Millions of children around the world are
            still denied their rights, simply because of who they are or where
            they are from.
          </p>
          <p className='save-the-children py-2'>
            We are committed to working until every child has the chance for a
            future. We will not give up until every child can: Grow up healthy
            and strong. Learn and reach their full potential. Be safe from
            violence and abuse Be free from discrimination. Have a say in their
            own lives
          </p>
          <p className='save-the-children py-2'>
            Every child deserves a chance to dream, to explore their passions, and to
            contribute meaningfully to the world. We empower children to
            break the cycle of poverty and build a brighter tomorrow. Together, we
            can create a world where every child's potential is unlocked, where
            their laughter and dreams know no bounds. Join us in our mission to
            transform lives and ensure that no child is left behind.
          </p>

        </div>
        <footer>
          <div className='donate-now'>
            <Link to='/amount'>
              <button className='btn-donate'>Donate Now</button>
            </Link>
          </div>
        </footer>
      </div>
    </div>
  );
}
